"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookmark = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var bookmark = function bookmark(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'bookmark-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // eslint-disable-next-line max-len
    d: 'M15.25 3.25L4.75 3.25L4.75 16.5986L9.58398 13.376C9.8359 13.208 10.1641 13.208 10.416 13.376L15.25 16.5986V3.25ZM16.75 2.5V18C16.75 18.2766 16.5978 18.5307 16.3539 18.6613C16.11 18.7918 15.8141 18.7775 15.584 18.624L10 14.9014L4.41603 18.624C4.18588 18.7775 3.88997 18.7918 3.64611 18.6613C3.40224 18.5307 3.25 18.2766 3.25 18L3.25 2.5C3.25 2.08579 3.58579 1.75 4 1.75L16 1.75C16.4142 1.75 16.75 2.08579 16.75 2.5Z',
    fill: '#4B5563'
  }));
};

exports.bookmark = bookmark;